
export default {"label":"Indicador de progreso que muestra que se está cargando contenido."}
